import { render, staticRenderFns } from "./SharedWishlist.vue?vue&type=template&id=60590ca1&scoped=true&"
import script from "./SharedWishlist.vue?vue&type=script&lang=js&"
export * from "./SharedWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60590ca1",
  null
  
)

export default component.exports